// frontend/src/components/charts/axisHeadroom.js

/** The value axis max that leaves 5% above the tallest value, or null when no value is above zero. */
export function headroomMax(dataMax) {
  return dataMax > 0 ? dataMax * 1.05 : null;
}
